__turbopack_context__.v({
  "description": "searchSnippet-module-scss-module__AjXh0W__description",
  "link": "searchSnippet-module-scss-module__AjXh0W__link",
  "searchSnippet": "searchSnippet-module-scss-module__AjXh0W__searchSnippet",
  "searchSnippetHeader": "searchSnippet-module-scss-module__AjXh0W__searchSnippetHeader",
});
